import {
  Actions,
  Subjects,
  useIsRbacEnabled,
  useIsTeamMultiSeat,
  useUserAbilitiesContext,
  useIsUserTeamAdminOrOwner,
} from 'context/user/UserContext';

export const useCanCreateTeamReplacements = () => {
  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();
  const canCreateTeamReplacementsLegacy = ability.can(
    Actions.UseFeature,
    Subjects.SharedLibrary
  );
  const canCreateTeamReplacementsRbac = ability.can(
    Actions.Create,
    Subjects.TeamReplacements
  );
  return isRbacEnabled
    ? canCreateTeamReplacementsRbac
    : canCreateTeamReplacementsLegacy;
};

export const useCanDeleteTeamReplacement = () => {
  const isUserTeamAdminOrOwner = useIsUserTeamAdminOrOwner();
  const isTeamUser = useIsTeamMultiSeat();
  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();

  const canDeleteTeamReplacementLegacy =
    isTeamUser &&
    isUserTeamAdminOrOwner &&
    ability.can(Actions.UseFeature, Subjects.SharedLibrary);
  const canDeleteTeamReplacementRbac = ability.can(
    Actions.Delete,
    Subjects.TeamReplacements
  );

  return isRbacEnabled
    ? canDeleteTeamReplacementRbac
    : canDeleteTeamReplacementLegacy;
};

export const useCanReadTeamReplacements = () => {
  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();
  const isTeamUser = useIsTeamMultiSeat();
  const canReadTeamReplacementsLegacy =
    isTeamUser && ability.can(Actions.UseFeature, Subjects.SharedLibrary);
  const canReadTeamReplacementsRbac = ability.can(
    Actions.Read,
    Subjects.TeamReplacements
  );
  return isRbacEnabled
    ? canReadTeamReplacementsRbac
    : canReadTeamReplacementsLegacy;
};

export const useCanImportReplacements = () => {
  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();
  const isTeamUser = useIsTeamMultiSeat();

  const canImportReplacementsLegacy =
    isTeamUser && ability.can(Actions.UseFeature, Subjects.SharedLibrary);

  const canImportReplacementRbac =
    ability.can(Actions.Update, Subjects.TeamLibrary) &&
    ability.can(Actions.Create, Subjects.TeamReplacements);

  return isRbacEnabled ? canImportReplacementRbac : canImportReplacementsLegacy;
};
export const useCanExportReplacements = () => {
  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();
  const isUserTeamAdminOrOwner = useIsUserTeamAdminOrOwner();

  const canExportReplacementLegacy =
    isUserTeamAdminOrOwner &&
    ability.can(Actions.Update, Subjects.TeamLibrary) &&
    ability.can(Actions.Create, Subjects.TeamReplacements);

  const canExportReplacementRbac = ability.can(
    Actions.Read,
    Subjects.TeamLibrary
  );
  return isRbacEnabled ? canExportReplacementRbac : canExportReplacementLegacy;
};

export const useCanUpdateTeamReplacements = () => {
  const isRbacEnabled = useIsRbacEnabled();
  const ability = useUserAbilitiesContext();
  const canUpdateReplacementLegacy = ability.can(
    Actions.UseFeature,
    Subjects.SharedLibrary
  );

  const canUpdateReplacementRbac = ability.can(
    Actions.Update,
    Subjects.TeamReplacements
  );

  return isRbacEnabled ? canUpdateReplacementRbac : canUpdateReplacementLegacy;
};

export default {
  useCanCreateTeamReplacements,
  useCanDeleteTeamReplacement,
  useCanReadTeamReplacements,
  useCanImportReplacements,
  useCanExportReplacements,
  useCanUpdateTeamReplacements,
};
